import { Injectable, computed, inject, signal } from '@angular/core';
import { SessionService } from './session.service';
import { CompaniesService } from '../../features/companies/data/services/companies.service';

export interface NavCompanyItem {
  id: number;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class CompanyContextService {
  private readonly sessionService = inject(SessionService);
  private readonly companiesService = inject(CompaniesService);

  readonly companies = signal<NavCompanyItem[]>([]);


  readonly isSuperAdmin = this.sessionService.isSuperAdmin;
  readonly isCompanyAdmin = this.sessionService.isCompanyAdmin;
  readonly selectedCompanyId = this.sessionService.selectedCompanyId;

  readonly selectedCompanyName = computed(() => {
    const selectedId = this.selectedCompanyId();
    const item = this.companies().find(c => c.id === selectedId);
    return item?.name ?? 'Select Company';

  });

  constructor() {
    this.refreshCompanies();
  }

  refreshCompanies(): void {
    if (this.isSuperAdmin()) {
      this.companiesService.getCompanies(1, 1000).subscribe({
        next: (response) => {
          if (response.success && response.data) {
            const mapped = response.data.companies.map(c => ({
              id: c.companyId,
              name: c.name
            }));
            this.companies.set(mapped);

          }
        }
      });
    }
  }

  setSelectedCompany(companyId: number): void {
    this.sessionService.updateSelectedCompany(companyId);
  }

  shouldShowCompanyDropdown(): boolean {
    return this.isSuperAdmin();
  }
}